import React from 'react';
import '../styles/emptyList.scss';

export const EmptyList = props => {
    return (
        <div className='empty-list'>
            {props.message}
        </div>
    )
}